import React from 'react';
import $ from "jquery";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { Input, Grid, Dropdown, Form, TextArea, Loader } from 'semantic-ui-react';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import ReadCookie from '../../../functions/readcookies';
import Loading from '../../loading';
import Server from '../../../functions/server';

export default class JobCard extends React.Component {

    state = {
        values: {}, data: [], plannedWork: []
    }

    componentDidMount() {
        let data = (ReadCookie("branch"));
        let branch_id = 0;
        for (var i = 0; i < data.length; i++) {
            branch_id = data[i].branch_id;
        }
        this.setState({ branch_id })
    }

    getCustomerAndLabor = () => {
        let context = this;
        context.setState({ load: true, message: 'Getting Customer And Labor Details', })
        $.ajax({
            type: 'POST', url: Server() + 'Sales/JobCard/GetCustomerAndLabor.php',
            success: function (data) {
                try {
                    data = JSON.parse(data);
                    if (context.props.edit) {
                        let values = context.props.item;
                        values["pdate"] = values.date;
                        context.setState({ dialog: true, values: context.props.item, data, load: false })
                    }
                    else {
                        context.setState({ dialog: true, values: {}, data, load: false })
                    }
                } catch (error) {
                    context.setState({ load: false })
                    alert(error)
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
    }

    convertIntoNumber(value) {
        try {
          value = Number(value);
        } catch (error) {
          value = 0;
        }
        return value
      }

    handleChange = name => event => {
        if (name == 'pdate') {
            this.getPlannedWorkForMachanic(event.target.value, this.state.values.eid);
        }
        if (name == 'eid') {
            this.getPlannedWorkForMachanic(this.state.values.pdate, event.target.value);
        }
        if (name == 'estimate_time') {
            let price = this.convertIntoNumber(this.state.values.price);
            let tax = this.convertIntoNumber(this.state.values.tax);
            let estimate_time = this.convertIntoNumber(event.target.value);
            price = (price + ((price * tax)/100)) * estimate_time;
            this.setState({
                values: {
                ...this.state.values,
                [name]: event.target.value,
                'tprice': price
                },
            });
            return;
        }
        this.setState({
            values: {
            ...this.state.values,
            [name]: event.target.value,
            },
        });
    };

    getPlannedWorkForMachanic = (date, id) => {
        if (!date || !id) {
           return; 
        }
        let context = this;
        context.setState({ load1: true, message: 'Getting Customer And Labor Details', })
        $.ajax({
            type: 'POST', data: { date, id }, url: Server() + 'Sales/JobCard/GetWorkForMachanic.php',
            success: function (data) {
                try {
                    data = JSON.parse(data);
                    context.setState({ plannedWork: data, load1: false })
                } catch (error) {
                    context.setState({ loa1d: false })
                    alert(error)
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
    }

    selectMode = (f, { value }) => {
        this.setState({
            values: {
            ...this.state.values,
            "mode": value,
            },
        });
    }

    selectCustomer = (f, { value }) => {
        this.getPlannedWorkForMachanic(this.state.values.pdate, value);
        let data = this.state.data;
        let estimate_time = this.convertIntoNumber(this.state.values.estimate_time);
        let price = 0;
        let tax = 0;
        data.map((c) => {
            if (c.type == 'Labor' && c.id == value) {
                price = this.convertIntoNumber(c.price);
                tax = this.convertIntoNumber(c.tax);
            }
        })
        estimate_time = estimate_time * (price + ((price * tax)/100));
        this.setState({
            values: {
            ...this.state.values,
            "eid": value,
            "price": price,
            "tax": tax,
            "tprice": estimate_time
            },
        });
    }

    makeCustomerDropdownOption = () => {
        let data = this.state.data;
        let option = [];
        data.map((c) => {
            if (c.type == "Customer") {
                option.push({ key: c.name+" -> "+c.mobile+" -> "+c.taluk, text: c.name+" -> "+c.mobile+" -> "+c.taluk, value: c.id })
            }
        })
        return option;
    }

    makeLaborDropdownOption = (type) => {
        let data = this.state.data;
        let option = []; 
        data.map((c) => {
            if (c.type == "Labor") {
                option.push({ key: c.name+" -> "+c.mobile+" -> "+c.taluk, text: c.name+" -> "+c.mobile+" -> "+c.taluk, value: c.id })
            }
        })
       
        return option;
    }

    submit = () => {
        let context = this;
        context.setState({ load: false, message: 'Add Job Master Details', })
        let values = this.state.values;
        let url = Server() + 'Sales/JobCard/AddJob.php';
        if (this.props.edit) {
            url = Server() + 'Sales/JobCard/EditJob.php';
        }
        else {
            values["branch_id"] = this.state.branch_id;
            values["mid"] = this.props.item.id;
            values["cid"] = this.props.item.cid;
        }
        $.ajax({
            type: 'POST', data: values, url,
            success: function (data) {
                console.log(data);
                if (data == 1) {
                    context.props.refresh();
                    context.setState({ load: false, values: {}, dialog: false })
                }
                else {
                    alert('Error')
                    context.setState({ load: false,  })
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
    }

    render() {
        let { load, load1, message, dialog, values, plannedWork } = this.state;
        let { item, edit, jobitem } = this.props;
        let customerOption = this.makeCustomerDropdownOption();
        let LaborOption = this.makeLaborDropdownOption();

        let modeOption = [
            { text: 'Minor', key: 'Minor', value: 'Minor' },
            { text: 'Semi Major', key: 'Semi Major', value: 'Semi Major' },
            { text: 'Major', key: 'Major', value: 'Major' },
            { text: 'Free Service', key: 'Free Service', value: 'Free Service' },
            { text: 'Warrenty Service', key: 'Warrenty Service', value: 'Warrenty Service' },
            { text: 'Other', key: 'Other', value: 'Other' }
        ]
        return (
            <div>
                { edit ?
                    <div style={{cursor: 'pointer'}} onClick={this.getCustomerAndLabor}>Edit</div>
                    :
                    <Button onClick={this.getCustomerAndLabor}>Add Job</Button>
                }
                <Dialog fullWidth={false} maxWidth={'md'} open={dialog}
                    onClose={ () => { this.setState({ dialog: false }) }}>
                    <DialogTitle id="responsive-dialog-title" style={{width: '800px'}}> {"Create Job"} </DialogTitle>
                    <DialogContent>
                        <Grid>
                            <Grid.Column mobile={16} tablet={16} computer={16}>
                                <b>Problem</b>
                                <Form>
                                    <TextArea fluid placeholder='Tell us more' onChange={this.handleChange('issue')} value={values.issue}  />
                                </Form>
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={16} computer={6}>
                                <b>Select Mechanic</b>
                                <Dropdown fluid search onChange={this.selectCustomer} selection 
                                    options={LaborOption} value={values.eid} />
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={16} computer={6}>
                                <b>Select Planning Date</b>
                                <input type="date" id="date" value={values.pdate}
                                    onChange={this.handleChange('pdate')} style={{width: '100%', height: 35 }} />
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={16} computer={3}>
                                <br/>
                                { load1 ? 
                                    <Loader /> :
                                    <b onClick={ () => this.setState({ viewPlannedWorked: true }) }>
                                        <u style={{color: 'blue'}}>{plannedWork.length+' Planned work(s) on this date.'}</u>
                                    </b>
                                }
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={16} computer={3}>
                                <b>Select Mode</b>
                                <Dropdown fluid search onChange={this.selectMode} selection 
                                    options={modeOption} value={values.mode} />
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={16} computer={3}>
                                <b>Price Per Hour</b><br/>
                                <Input type={'number'} fluid placeholder='Price Per Hour' value={values.price} 
                                    onChange={this.handleChange('price')} />
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={16} computer={3}>
                                <b>Tax</b><br/>
                                <Input type={'number'} fluid placeholder='Tax' value={values.tax} disabled={true}
                                    onChange={this.handleChange('tax')} />
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={16} computer={3}>
                                <b>Estimate Time</b><br/>
                                <Input type={'number'} fluid placeholder='Estimate Time' value={values.estimate_time} 
                                    onChange={this.handleChange('estimate_time')} />
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={16} computer={4}>
                                <b>Total Price</b><br/>
                                <Input type={'number'} fluid placeholder='Total Price' value={values.tprice} 
                                    onChange={this.handleChange('tprice')} />
                            </Grid.Column>
                        </Grid>
                        <Dialog fullWidth={false} maxWidth={'md'} open={this.state.viewPlannedWorked}
                            onClose={ () => { this.setState({ viewPlannedWorked: false }) }}>
                            <DialogTitle id="responsive-dialog-title" style={{width: '800px'}}> {"Planned Work"} </DialogTitle>
                            <DialogContent>
                                <table width="100%" id="table">
                                    <tr>
                                        <th id='tableheader'><center>Planned Date</center></th>
                                        <th id='tableheader'><center>Issue</center></th>
                                        <th id='tableheader'><center>Machanic Name</center></th>
                                        <th id='tableheader'><center>Estimate Time</center></th>
                                        <th id='tableheader'><center>Rate</center></th>
                                        <th id='tableheader'><center>Tax</center></th>
                                        <th id='tableheader'><center>Total</center></th>
                                        <th id='tableheader'><center>Status</center></th>
                                    </tr>
                                    {
                                        plannedWork.map((c) => {
                                            return (
                                                <tr>
                                                    <td>{c.date}</td>
                                                    <td>{c.title}</td>
                                                    <td>{c.worker_name}</td>
                                                    <td>{c.estimate_time+" Hour(s)"}</td>
                                                    <td style={{textAlign: 'right'}}>{c.price}</td>
                                                    <td style={{textAlign: 'right'}}>{c.tax}</td>
                                                    <td style={{textAlign: 'right'}}>{c.tprice}</td>
                                                    <td style={{textAlign: 'right'}}>
                                                        {
                                                            c.status == 1 || c.status == '1' ? 
                                                            <div  style={{color: 'blue', cursor: 'pointer'}}>Process</div> : 
                                                            <div style={{color: 'green'}}>Completed</div>
                                                        }
                                                    </td>
                                                    
                                                </tr>
                                            )
                                        })
                                    }
                                </table>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={ () => { this.setState({ viewPlannedWorked: false }) }}>Close</Button>
                            </DialogActions>
                        </Dialog>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ dialog: false }) }}>Close</Button>
                        <Button onClick={this.submit}>Submit</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}